export const DEFAULT_LIST_PAGE_SIZE = 100;

export const LIST_PAGE_SIZE_OPTIONS = [10, 15, 20, 25, 30, 50, 100] as const;
